import React from 'react';
import { Paper, Typography, Stack, Button } from '@mui/material';
import { Person, Email, Phone, ArrowForward } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const Field = ({ icon: Icon, value }) =>
    value ? (
        <Stack direction="row" spacing={1} alignItems="center">
            <Icon fontSize="small" color="action" />
            <Typography variant="body2">{value}</Typography>
        </Stack>
    ) : null;

const OrderCustomerCard = ({ order }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const customer = order?.user || order?.customer;
    if (!customer) return null;

    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 2, md: 2.5 },
                borderRadius: 3,
                border: (t) => `1px solid ${t.palette.divider}`,
                mb: 2,
            }}
        >
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
                <Typography variant="subtitle1" fontWeight={700}>
                    {isArabic ? 'العميل' : 'Customer'}
                </Typography>
                {customer.id && (
                    <Button
                        component={RouterLink}
                        to={`/customers/${customer.id}`}
                        size="small"
                        endIcon={<ArrowForward sx={{ transform: isArabic ? 'rotate(180deg)' : 'none' }} />}
                    >
                        {isArabic ? 'عرض' : 'View'}
                    </Button>
                )}
            </Stack>

            <Stack spacing={0.75}>
                <Field icon={Person} value={customer.name} />
                <Field icon={Email}  value={customer.email} />
                <Field icon={Phone}  value={customer.phone} />
            </Stack>
        </Paper>
    );
};

export default OrderCustomerCard;
